import type { SDKState } from "@/state/sdk-state";
import { SimpleObservable, SimpleObservableSubject } from "@/utils/observable";
import { AuthIframeBroker } from "./auth-iframe-broker";
import type { Logger } from "@/utils/logger";

export class AuthIframeManager extends SimpleObservable {
  #logger: Logger;
  #iframe: HTMLIFrameElement | null = null;
  broker: AuthIframeBroker;

  constructor(
    state: SDKState,
    logger: Logger,
    authIframeBroker?: AuthIframeBroker,
  ) {
    super();
    this.#logger = logger.extend(this.constructor.name);
    this.broker = authIframeBroker ?? new AuthIframeBroker(state, logger);
  }

  init() {
    this.broker.init();
  }

  detach() {
    this.broker.detach();
  }

  async attachIframe(iframe: HTMLIFrameElement) {
    document.body.appendChild(iframe);
  }

  async detachSilentIframe() {
    if (!this.#iframe) {
      return;
    }

    if (this.#iframe.parentElement) {
      this.#iframe.parentElement.removeChild(this.#iframe);
    } else {
      document.body.removeChild(this.#iframe);
    }

    this.#iframe = null;
  }

  async createSilentIframe(src: string) {
    const iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.style.visibility = "hidden";
    iframe.style.position = "fixed";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "1px";
    iframe.style.height = "1px";
    iframe.style.zIndex = "1px";
    iframe.style.border = "none";
    iframe.style.opacity = "0";

    this.#iframe = iframe;
    this.attachIframe(iframe);
  }
}
